/*
 * Café · photos d'origine.
 *
 * La bande défile nativement : le rôle du script se limite à trois choses que
 * le CSS ne sait pas faire. Montrer les flèches seulement s'il y a matière à
 * défiler, avancer d'une photo à la fois, et griser la flèche arrivée au bout.
 *
 * Si le script ne se charge pas, la bande reste défilable au doigt, au
 * trackpad et au clavier. Les flèches restent simplement cachées.
 */

class CafeGalerie extends HTMLElement {
  connectedCallback() {
    this.commandes = this.closest('.cafe-galerie')?.querySelector('[data-cafe-galerie-commandes]');
    this.precedent = this.commandes?.querySelector('[data-cafe-galerie-precedent]');
    this.suivant = this.commandes?.querySelector('[data-cafe-galerie-suivant]');

    this.addEventListener('scroll', this.rafraichir.bind(this), { passive: true });
    this.precedent?.addEventListener('click', () => this.deplacer(-1));
    this.suivant?.addEventListener('click', () => this.deplacer(1));

    if (typeof ResizeObserver === 'function') {
      this.observateur = new ResizeObserver(this.rafraichir.bind(this));
      this.observateur.observe(this);
    } else {
      window.addEventListener('resize', this.rafraichir.bind(this));
    }

    /*
     * Les photos sont chargées en différé et n'ont pas de largeur tant qu'elles
     * ne sont pas arrivées : c'est leur proportion qui la donne. Tant que la
     * première n'est pas là, le pas et le débordement sont faux. On recalcule
     * donc à chaque arrivée, sans attendre le chargement complet de la page.
     */
    this.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', () => this.rafraichir(), { once: true });
    });

    this.rafraichir();
  }

  disconnectedCallback() {
    this.observateur?.disconnect();
  }

  /*
   * Le pas est la largeur d'une photo, gouttière comprise. Le repli sur quatre
   * cinquièmes de la bande sert au cas où la mesure vaut zéro, c'est-à-dire
   * avant que la première photo soit arrivée : sans lui, la flèche ne ferait
   * rien du tout au premier clic.
   */
  get pas() {
    const vues = this.querySelectorAll('[data-cafe-galerie-vue]');
    let mesure = 0;

    if (vues.length > 1) {
      mesure = vues[1].getBoundingClientRect().left - vues[0].getBoundingClientRect().left;
    } else if (vues.length === 1) {
      mesure = vues[0].getBoundingClientRect().width;
    }

    return mesure > 40 ? mesure : this.clientWidth * 0.8;
  }

  deplacer(sens) {
    this.scrollBy({ left: this.pas * sens, behavior: 'smooth' });
  }

  rafraichir() {
    const debordement = this.scrollWidth - this.clientWidth;
    /* Deux pixels de tolérance : les largeurs fractionnaires ne tombent jamais juste. */
    const defilable = debordement > 2;

    if (this.commandes) this.commandes.hidden = !defilable;
    if (this.precedent) this.precedent.disabled = this.scrollLeft <= 2;
    if (this.suivant) this.suivant.disabled = this.scrollLeft >= debordement - 2;
  }
}

customElements.define('cafe-galerie', CafeGalerie);
